import React from 'react';
import { FileText, Scale, User, Shield, Users, MessageSquare } from 'lucide-react';
export function OpeningStatement() {
  return <section className="relative pt-0 pb-24 px-6 md:px-12 lg:px-24 bg-white border-b border-gray-100" data-id="element-1136">
      <div className="max-w-7xl mx-auto" data-id="element-1137">
        {/* Full-width rule */}
        <div className="h-px bg-gray-200 w-full mb-12" data-id="element-1138"></div>

        {/* Two-column layout: text left, pills right */}
        <div className="grid grid-cols-1 lg:grid-cols-[1.6fr,1fr] gap-12 items-start" data-id="element-1139">
          {/* Left column - Text content */}
          <div className="max-w-3xl" data-id="element-1140">
  <h2 className="text-3xl md:text-4xl lg:text-4.5xl font-bold mb-8 leading-tight tracking-tight font-['Syne']" data-id="element-1141">
    <span className="text-black block" data-id="element-1142">
      The Context Your AI
    </span>
    <span className="text-black" data-id="element-1143">Has Been Missing</span>
  </h2>
  <p className="text-xl text-gray-600 leading-relaxed font-light max-w-xl" data-id="element-1144">
    From policies to personas to brand voice. Synthia converts your institutional knowledge into contextual intelligence that deploys automatically—giving every model, every tool, every interaction the context it needs to work the way you do.
  </p>
        </div>
          {/* Right column - Floating pill badges */}
          <div className="hidden lg:flex flex-col items-end space-y-3 -mt-0" data-id="element-1145">
            <div className="inline-flex items-center gap-3 px-6 py-3 rounded-full border border-green-200 bg-green-50 text-green-700 text-xl font-medium mr-10 font-sans" data-id="element-1146">
              <FileText className="w-6 h-6" data-id="element-1147" />
              Executive Ghostwriting
            </div>

            <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full border border-yellow-400 bg-yellow-50 text-yellow-700 text-sm font-medium mr-20 font-sans" data-id="element-1148">
              <Scale className="w-3.5 h-3.5" data-id="element-1149" />
              Counterfactual Reasoning
            </div>

            <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full border border-blue-200 bg-blue-50 text-blue-700 text-sm font-medium mr-8 font-sans" data-id="element-1150">
              <User className="w-3.5 h-3.5" data-id="element-1151" />
              Role: Chief Marketing Officer
            </div>

            <div className="inline-flex items-center gap-2 px-5 py-2.5 rounded-full border border-pink-200 bg-pink-50 text-pink-700 text-lg font-medium mr-24 font-sans" data-id="element-1152">
              <Shield className="w-5 h-5" data-id="element-1153" />
              HIPAA Compliance
            </div>

            <div className="flex gap-3 mt-2" data-id="element-1154">
              <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full border border-blue-200 bg-blue-50 text-blue-700 text-sm font-medium font-sans" data-id="element-1155">
                <Users className="w-3.5 h-3.5" data-id="element-1156" />
                Investor Personas
              </div>

              <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full border border-green-200 bg-green-50 text-green-700 text-sm font-medium font-sans" data-id="element-1157">
                <MessageSquare className="w-3.5 h-3.5" data-id="element-1158" />
                Patient Communications
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}